import styled from "styled-components";

export const BreadCrumbWrapper = styled.div`
  display: flex;
  align-items: center;
  .active {
    color: #0C53BB;
  }
`;

export const BreadCrumbLabel = styled.div`
  display: flex;
  align-items: center;
  font-family: 'Manrope', sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 100%;
  color: #48566B;
  margin-left: 2px;
  gap: 3px;
  cursor: pointer;
`;

export const BreadcrumbSeparator = styled.span`
  display: inline-flex;
  align-items: center;
  color: #7688A3;
  margin: 0 2px;
`;

export const BreadcrumbrumbText = styled.div`
  font-family: 'Manrope', sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 100%;
  color: #48566B;
  max-width: 100px;
  width: fit-content;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }

  &.active {
    color: #0C53BB;
  }
`;

export const EllipsisWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 200px;
  overflow-y: auto;
`;

export const TooltipItem = styled.div`
  padding: 6px 8px;
  cursor: pointer;
  font-size: 12px;
  font-family: 'Manrope', sans-serif;
  color: #48566B;
  border-radius: 4px;
  &:hover {
    background-color: #F5F6F9;
  }
`;
